import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  files: [],
};

const filesSlice = createSlice({
  name: 'statistics',
  initialState,
  reducers: {
    addFilesRedux(state, { payload }) {
      state.files = payload;
      // console.log(payload);
    },
    addFileRedux(state, { payload }) {
      state.files.unshift(payload);
      // console.log(payload);
    },
    // Приклад використання
    // dispatch(deleteItemFromArrayRedux({ field: "files", id: id }));
    deleteItemFromArrayRedux(state, { payload }) {
      const { field, id } = payload;
      state[field] = state[field].filter((item) => item.id !== id);
    },
  },
});

export const { addFileRedux, addFilesRedux, deleteItemFromArrayRedux } = filesSlice.actions;

export default filesSlice.reducer;
